<template>
    <tr  class="black_line">
        <td class="nameCol">
            {{setting.name}}
        </td>
        <td class="valCol">
                        
            <input  v-if="setting.type == 'boolean'"
                v-model="model_setting.val"
                class="custom_checkbox"
                type="checkbox"
                :checked="model_setting.val"
                :id="`${setting.name}_custom`"
                :value="model_setting.val"
                @change="changeVal('val', model_setting.val)"
            >
            <label  v-if="setting.type == 'boolean'"
                :for="`${setting.name}_custom`"
            ></label>
            
            <input  v-if="setting.type != 'boolean'"
                v-model="model_setting.default"
                class="custom_checkbox"
                type="radio"
                :checked="!setting.default"
                :id="`${setting.name}_custom`"
                value=0
                @change="changeVal('default', model_setting.default)"
            >            
            <label  v-if="setting.type != 'boolean'"
                :for="`${setting.name}_custom`"
            ></label>
            <select v-if="hasOptions"
                v-model="model_setting.val"
                class="custom_number custom_select"
                :name="setting.name"
                @change="changeVal('val', model_setting.val)"
                :disabled="model_setting.default == 1"
            >
                <option v-for="opt in setting.options" :key="opt" :value="opt">{{opt}}</option>
            </select>
            <input v-else-if="setting.type === 'string'"
                v-model="model_setting.val"
                type="text"
                class="custom_number custom_text"
                :name="setting.name"
                @change="changeVal('val', model_setting.val)"
                :disabled="model_setting.default == 1"
            >
            <input v-else-if="setting.type != 'boolean'"
                v-model="model_setting.val"                 
                type="number" 
                step=0.01
                class="custom_number"
                :name="setting.name" 
                @change="changeVal('val', model_setting.val)"
                :disabled="model_setting.default == 1"
            >            
        </td>
        <td class="defValCol">
            <input v-if="setting.type != 'boolean'"
                v-model="model_setting.default"
                class="custom_checkbox"
                type="radio"
                :checked="model_setting.default"
                :id="`${setting.name}_default`"
                value=1
                @change="changeVal('default', model_setting.default)"
            >
            <label  v-if="setting.type != 'boolean'"
                :for="`${setting.name}_default`"
            >
                {{setting.defval}}
            </label>
        </td>
        <td>
            <input
                class="description" 
                v-model="model_setting.description" 
                type="text" 
                @change="changeVal('description', model_setting.description)"                
            />
        </td>
    </tr>
</template>

<script>

import {bus} from '../../bus';

export default {
    props: [
        'setting'        
    ],
    data(){
        return{
            model_setting: {
                val: '',
                defval: '',
                default: '',
                type: '',
                description: '',
                id: ''
            },
            newData: {}
        }
    },    
    methods: {       
        changeVal(valName, val){
            console.log('this.model_setting.val: ', this.model_setting.val);
            if(this.setting.type == 'boolean')
                val = val ? 1 : 0;
            console.log(val);
            this.newData[valName] = val;            
        }
    },
    mounted(){
        this.model_setting = this.setting;
        if(this.setting.type == 'boolean')
                this.model_setting.val = this.model_setting.val == '0' ? false : true;
        bus.$on('updateSetting', () => {            
            if(Object.keys(this.newData).length !== 0){                
                
                console.log( 'this.newData: ', this.newData);
                axios.put( `/settings/${this.setting.id}`,
                    this.newData
                ).then((responce)=>{
                    // console.log('update setting', responce);
                    console.log('update setting responce.data', responce.data);
                    this.newData = {};
                    alert(`${this.setting.name} saved`);
                }).catch(function(error){
                    console.log('FAILURE update person: ');
                    console.log(error);
                });
            }
        });
        
        
    },
     computed: {
        hasOptions(){
            return Array.isArray(this.setting.options) && this.setting.options.length > 0;
        }
     }
}
</script>

<style lang="scss" scoped>
    input {
        color: #E0E0E0;        
    }
    input.description {
        border: none;
    }
    input.custom_number  {
        width: 90px;
        margin-left: 10px;
        border-left: none;
        border-top: none;
        border-right: none;
        padding-bottom: 5px;
    }
    select.custom_select {
        width: 120px;
        margin-left: 10px;
        color: #E0E0E0;
        background: transparent;
        border: none;
        border-bottom: 1px solid rgba(255, 255, 255, 0.3);
        padding-bottom: 5px;
        cursor: pointer;
    }
    select.custom_select option {
        color: #000;
    }
    input[type="radio"],
    label
    {
        cursor: pointer;
    }
    .valCol {
        width: 170px;
    }
    .defValCol {
        width: 160px;
    }
    .nameCol {
        width: 200px;
    }
    .custom_checkbox + label::before {
        content: "";
        display: inline-block;
        width: 1em;
        height: 1em;
        flex-shrink: 0;
        flex-grow: 0;
        border: 1px solid #074af8;
        border-radius: 0.25em;
        margin-right: 15px;
        background-repeat: no-repeat;
        background-position: center center;
        background-size: 70% 70%;
    }
    .custom_checkbox + label {
        display: inline-block;
        margin-top: 3px;
    }
</style>
